import { create } from 'apisauce';
import { a as apiClient$1 } from '../../dist/client-e97f9d41.esm.js';
import '../../dist/asyncToGenerator-c002e3ca.esm.js';
import '@react-native-async-storage/async-storage';
import 'dayjs';

var apiClient = {
  apiClient: apiClient$1,
  create: create
};

export { apiClient as default };
